export default __webpack_public_path__ + "static/media/signout.973c2d8b.png";